export const has = (element, attribute) => {
  if (element && element.hasAttribute && element.hasAttribute(attribute)) {
    return element.getAttribute(`data-${attribute}`) !== null || ''
  }

  return false
}
